const OAUTH = {
  authorizeUrl: "https://connect.ligue1.fr/authorize",
  clientId: "XNNUupMREjh0ULck1InJRC6gb8kyMfdg",
  redirectUri: "https://mpg.football",
  scope: "openid profile email offline_access",
  audience: "https://mpg.ligue1.fr",
};

const base64url = (bytes) => btoa(String.fromCharCode(...new Uint8Array(bytes)))
  .replace(/\+/g, "-")
  .replace(/\//g, "_")
  .replace(/=+$/, "");

export const generateCodeVerifier = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return base64url(bytes);
};

export const computeCodeChallenge = async (verifier) => {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return base64url(digest);
};

export const buildAuthorizeUrl = async ({ verifier, state, nonce }) => {
  const url = new URL(OAUTH.authorizeUrl);
  url.search = new URLSearchParams({
    client_id: OAUTH.clientId,
    redirect_uri: OAUTH.redirectUri,
    response_type: "code",
    response_mode: "query",
    scope: OAUTH.scope,
    audience: OAUTH.audience,
    code_challenge: await computeCodeChallenge(verifier),
    code_challenge_method: "S256",
    state,
    nonce,
    prompt: "login",
    ui_locales: "fr",
  }).toString();
  return url.toString();
};

export const parseCallback = (input) => {
  if (! input) {
    return null;
  }
  const trimmed = input.trim();
  if (trimmed.includes("code=") || trimmed.includes("://")) {
    try {
      const u = new URL(trimmed, "https://mpg.football");
      const code = u.searchParams.get("code");
      if (! code) {
        return null;
      }
      return {
        code,
        state: u.searchParams.get("state") ?? "",
      };
    } catch {
      return null;
    }
  }
  return {
    code: trimmed,
    state: "",
  };
};